import React, { Component } from "react";
import classNames from "classnames";
import styles from "./PizhuanItem.module.css";
import { format as formatDate } from 'date-fns';
import { IPizhuan, ITenderStatusConfig, ITenderStatus } from "../../api";
import { formatRemainTime } from "../../utils"
import { tenderStatusConfigEnum, tenderStatusEnum } from "../../constant"

interface PizhuanProps {
  pizhuanInfo: IPizhuan
}

class PizhuanItem extends Component<PizhuanProps> {
  getStatusConfig = () => {
    const { pizhuanInfo } = this.props
    let {
      tenderStatus
    } = pizhuanInfo

    return tenderStatusConfigEnum[tenderStatus as keyof ITenderStatusConfig] ? tenderStatusConfigEnum[tenderStatus as keyof ITenderStatusConfig] : {
      label: '',
      text: '',
      class: ''
    }
  }

  getStatusTime = () => {
    const { pizhuanInfo } = this.props
    let {
      tenderStatus,
      tenderStartTime,
      tenderEndTime,
      remainTime
    } = pizhuanInfo
    if (tenderStatusEnum.todo.includes(tenderStatus)) {
      return formatDate(tenderStartTime, 'MM月dd日 HH:mm:ss')
    } else if (tenderStatusEnum.done.includes(tenderStatus)) {
      return formatDate(tenderEndTime, 'MM月dd日 HH:mm:ss')
    } else if (tenderStatusEnum.doing.includes(tenderStatus)) {
      const {
        dayNum,
        hourNum,
        minuteNum,
        secondNum
      } = formatRemainTime(remainTime / 1000)
      return `距离结束 ${dayNum > 0 ? dayNum + '天' : ''}${hourNum}小时${minuteNum}分${secondNum}秒`
    }
    return ''
  }

  render() {
    const { pizhuanInfo } = this.props
    let {
      id,
      projectName,
      operatorTime,
      cateName,
      vendorName,
    } = pizhuanInfo
    const {
      label: statusTitle,
      class: statusClass
    } = this.getStatusConfig()
    const statusTime = this.getStatusTime()
    return (
      <a
        className={styles["pizhuan-item-container"]}
        href={`//zcch.jd.com/cession/${id}`}
        target="_blank"
      >
        <div className={styles["pizhuan-item"]}>
          <div className={styles["item-body"]}>
            <h4 className={styles["item-title"]}>{projectName}</h4>
            <div className={styles["item-info"]}>
              <p>发布时间：{formatDate(operatorTime, 'MM月dd日 hh:mm:ss')}</p>
              {
                cateName ? (
                  <p>资产类型：{cateName}</p>
                ) : ''
              }
              <p>处置主体：{vendorName}</p>
            </div>
          </div>
          <div
            className={styles["item-status"]}
          >
            <span className={classNames(styles["status-title"], styles[`status-title--${statusClass}`])}>{statusTitle}</span>
            <span className={styles["status-countdown"]}>{statusTime}</span>
          </div>
        </div>
        <div className={styles["item-border"]}></div>
      </a>
    )
  }
}

export default PizhuanItem;
